// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { post, put } from '../../../../common/api'
import { ADD_DESIGNATION, DELETE_DESIGNATION, DESIGNATION, EDIT_DESIGNATION, GET_DESIGNATION } from '../../../../common/constant'

export const actionDesignation = createAsyncThunk('appDesignation/actionDesignation', async (params, thunkAPI) => {
    return await post(DESIGNATION, params, thunkAPI)
})

export const actionAddDesignation = createAsyncThunk('appDesignation/actionAddDesignation', async (params, thunkAPI) => {
    return await put(ADD_DESIGNATION, params, thunkAPI)
})

export const actionGetDesignation = createAsyncThunk('appDesignation/actionGetDesignation', async (params, thunkAPI) => {
    return await post(GET_DESIGNATION, params, thunkAPI)
})

export const actionEditDesignation = createAsyncThunk('appDesignation/actionEditDesignation', async (params, thunkAPI) => {
    return await post(EDIT_DESIGNATION, params, thunkAPI)
})

export const actionDeleteDesignation = createAsyncThunk('appDesignation/actionDeleteDesignation', async (params, thunkAPI) => {
    return await post(DELETE_DESIGNATION, params, thunkAPI)
})

export const appDesignationSlice = createSlice({
    name: 'appDesignation',
    initialState: {
        //list
        loading: false,
        designation: null,

        //add
        loadingAdd: false,
        addDesignation: null,

        //get
        loadingGet: false,
        getDesignation: null,

        //edit
        loadingEdit: false,
        editDesignation: null,

        //delete
        loadingDelete: false,
        deleteDesignation: null

    },
    reducers: {
        //reset or delete Add Insurance Company store data
        resetDesignationResponse: (state) => {
            state.designation = null
        },
        resetAddDesignationResponse: (state) => {
            state.addDesignation = null
        },
        resetGetDesignationResponse: (state) => {
            state.getDesignation = null
        },
        resetEditDesignationResponse: (state) => {
            state.editDesignation = null
        },
        resetDeleteDesignationResponse: (state) => {
            state.deleteDesignation = null
        }
    },
    extraReducers: builder => {
        builder
            //list
            .addCase(actionDesignation.pending, (state) => {
                state.loading = true
            })
            .addCase(actionDesignation.fulfilled, (state, action) => {
                state.loading = false
                state.designation = action.payload
            })
            .addCase(actionDesignation.rejected, (state) => {
                state.loading = false
            })

            //add
            .addCase(actionAddDesignation.pending, (state) => {
                state.loadingAdd = true
            })
            .addCase(actionAddDesignation.fulfilled, (state, action) => {
                state.loadingAdd = false
                state.addDesignation = action.payload
            })
            .addCase(actionAddDesignation.rejected, (state) => {
                state.loadingAdd = false
            })

            // get
            .addCase(actionGetDesignation.pending, (state) => {
                state.loadingGet = true
            })
            .addCase(actionGetDesignation.fulfilled, (state, action) => {
                state.loadingGet = false
                state.getDesignation = action.payload
            })
            .addCase(actionGetDesignation.rejected, (state) => {
                state.loadingGet = false
            })

            //edit
            .addCase(actionEditDesignation.pending, (state) => {
                state.loadingEdit = true
            })
            .addCase(actionEditDesignation.fulfilled, (state, action) => {
                state.loadingEdit = false
                state.editDesignation = action.payload
            })
            .addCase(actionEditDesignation.rejected, (state) => {
                state.loadingEdit = false
            })

            //delete
            .addCase(actionDeleteDesignation.pending, (state) => {
                state.loadingDelete = true
            })
            .addCase(actionDeleteDesignation.fulfilled, (state, action) => {
                state.loadingDelete = false
                state.deleteDesignation = action.payload
            })
            .addCase(actionDeleteDesignation.rejected, (state) => {
                state.loadingDelete = false
            })
    }
})
export const { resetDesignationResponse, resetAddDesignationResponse, resetEditDesignationResponse, resetGetDesignationResponse, resetDeleteDesignationResponse } = appDesignationSlice.actions

export default appDesignationSlice.reducer